import React, {Component} from 'react';
import { Link } from 'react-router-dom';
import {Alert, Button, Card, Col, Form, FormGroup, Input, Label, Row} from 'reactstrap';
import axios from 'axios';
import { connect } from 'react-redux';
import {Spinner} from "react-bootstrap";
import "react-datepicker/dist/react-datepicker.css";

class ResetPasswordComponent extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            email: '',
            error: false,
            messageError: '',
            btnDisable: false,
        }
    }

    submitLogin = () => {
        // console.log( this.state.email + ' - ' + this.state.password + ' - ' + this.state.remember  );
        this.setState({
            btnDisable: true
        })
        let validate = this.validate();
        if ( validate ) {
            let item = {
                'email': this.state.email,
            };
            this.setState({
                isLoading: true
            });

            let dataAuth = {
                username: process.env.REACT_APP_CLIENT_ID,
                password: process.env.REACT_APP_CLIENT_PASSWD,
                token: process.env.REACT_APP_KEY,
            };

            axios.put( process.env.REACT_APP_API_URL + '/api/requestResetPassword', item,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'dataAgency' : JSON.stringify(dataAuth)
                    }
                }
            )
                .then( (ref) => {
                    this.setState({
                        isLoading: false
                    });
                    if ( ref.data.error === 0 ) {
                        // console.log(ref.data);
                        this.redirect( ref.data );
                    } else {
                        this.setState({
                            error: true,
                            messageError: ref.data.message,
                            btnDisable: false
                        })
                    }
                    // console.log(this.state.perPage);
                })
                .catch( (error) => {
                    console.log(error);
                    this.setState({
                        error: true,
                        messageError: 'Yêu cầu khôi phục mật khẩu cho tài khoản thất bại',
                        isLoading: false,
                        btnDisable: false
                    })
                })
        }
    }

    redirect = async (item) => {
        await this.props.updateSuccessNotiUser(item);
        await this.props.redirect();
    }

    validate = () => {
        if ( this.state.email.length === 0 ) {
            this.setState({
                error: true,
                messageError: 'Email không được để trống',
                btnDisable: false
            })
            return false;
        }
        return true;
    }

    changeInput = (event) => {
        let name = event.target.name;
        let value = event.target.type === 'checkbox' ? event.target.checked : event.target.value;
        this.setState({
            [name]: value
        });
    }

    render() {
        return (
            <>
                {
                    this.state.isLoading ? (
                        <div className="cr-page-spinner load-page">
                            <Spinner animation="border" variant="primary"/>
                        </div>
                    ) : (
                        <Row
                            style={{
                                height: '100vh',
                                justifyContent: 'center',
                                alignItems: 'center',
                            }}
                        >
                            <Col md={6} lg={4} className="m-3">
                                <Card body>
                                    <Form onSubmit={() => this.submitLogin()}>
                                        <div className="text-center pb-3">
                                            <img
                                                src={ this.props.config.website_logo }
                                                className="rounded"
                                                style={{ width: 90, height: "auto", cursor: 'pointer' }}
                                                alt="logo"
                                            />
                                            <h4 className="text-primary mt-2">{ this.props.config.website_company ? this.props.config.website_company : '' }</h4>
                                            <div className="m-2">
                                                <p className="mb-4">
                                                    Vui lòng nhập email đã đăng ký, chúng tôi sẽ gửi
                                                    đường dẫn khôi phục lại mật khẩu qua email này.
                                                </p>
                                            </div>
                                        </div>
                                        {
                                            this.state.error ? (

                                                <Alert color="danger">
                                                    <div className='text-center'>
                                                        { this.state.messageError }
                                                    </div>
                                                </Alert>
                                            ) : (
                                                <></>
                                            )
                                        }
                                        <FormGroup>
                                            <Label for={'Email'}>{'Email'}</Label>
                                            <Input type="email" placeholder="Email" name="email"  className="form-control" onChange={this.changeInput} value={this.state.email} />
                                        </FormGroup>
                                        <hr />
                                        <Button
                                            size="lg"
                                            className="bg-gradient-theme-left border-0"
                                            block
                                            onClick={() => this.submitLogin()}>
                                            Gửi email xác nhận
                                        </Button>
                                    </Form>
                                    <div className="text-center pt-1">
                                        <h6>hoặc</h6>
                                        <h6>
                                            <Link to="/dang-nhap.html">Đăng nhập</Link>
                                        </h6>
                                    </div>
                                </Card>
                            </Col>
                        </Row>
                    )
                }
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        emailSave: state.login.email,
        passwordSave: state.login.password,
        isSinged: state.login.isSinged,
        config: state.configSystem.config,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        remember: (item) => {
            dispatch(({ type : 'remember', item }))
        },
        login: (item) => {
            dispatch(({ type : 'login', item }))
        },
        updateSuccessNotiUser: (item) => {
            dispatch(({ type : 'updateSuccessNotiUser', item }))
        },
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(ResetPasswordComponent);